import React from "react";
import "./welcome.css";

const TeacherWelcome = () => {
  const now = new Date();

  const hours = now.getHours();
  const date = now.getDate();
  const month = now.toLocaleString("default", { month: "long" });
  const year = now.getFullYear();

  let greeting = "Welcome";
  if (hours < 12) greeting = "Good Morning";
  else if (hours < 16) greeting = "Good Afternoon";
  else greeting = "Good Evening";

  return (
    <div className="tw-container">
      {/* Date Box */}
      <div className="tw-date-box">
        <div className="tw-month">{month}</div>
        <div className="tw-date">{date}</div>
        <div className="tw-year">{year}</div>
      </div>

      {/* Greeting */}
      <h1 className="tw-greeting">{greeting} 🌸</h1>
      <p className="tw-subtext">
        Welcome to <strong>Bodhimaram Play School</strong>
      </p>

      {/* School Image */}
      <div className="tw-image-wrapper">
        <img
          src="https://campuspro.co.in/school-images/1740566075_BODHI%20MARAM%20PLAY%20SCHOOL%20&%20DAY%20CARE.jpg"
          alt="Bodhimaram Play School"
        />
      </div>
    </div>
  );
};

export default TeacherWelcome;
